import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../../hotel.service';

@Component({
  selector: 'app-free-cancel-filter',
  templateUrl: './free-cancel-filter.component.html',
  styleUrls: ['./free-cancel-filter.component.scss']
})
export class FreeCancelFilterComponent implements OnInit {
  isRefundable = false;
  isNonRefundable = false;
  hotelsCopy: any;
  protected subs = new SubSink();

  constructor(private hotelService: HotelService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    // Sync hotelsCopy from the service
    this.subs.sink = this.hotelService.hotelsCopy.subscribe(res => {
      this.hotelsCopy = res.length ? res : [];
      this.cdr.detectChanges();
    });
  
    // Sync component flags with service flags
    this.subs.sink = this.hotelService.isRefundable.subscribe(
      value => (this.isRefundable = value)
    );
    this.subs.sink = this.hotelService.isNonRefundable.subscribe(
      value => (this.isNonRefundable = value)
    );
  }


  onFilterChange() {
    this.hotelService.isRefundable.next(this.isRefundable);
    this.hotelService.isNonRefundable.next(this.isNonRefundable);

    // Trigger filter application
    this.hotelService.multipleFiltersApply();
}


  clearFilter() {
    this.hotelService.resetRefundableFilters();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
